import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-arrow-right.svg'


const _withScopeId = n => (_pushScopeId("data-v-29490ac6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = {
  key: 0,
  class: "text-[#9BB441]"
}
const _hoisted_6 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex flex-col justify-start items-start" }
const _hoisted_9 = {
  key: 0,
  class: "text-[12px] text-left"
}
const _hoisted_10 = {
  key: 1,
  class: "text-[12px] text-left"
}
const _hoisted_11 = { class: "text-[12px]" }
const _hoisted_12 = {
  key: 2,
  class: "text-[12px]"
}
const _hoisted_13 = {
  key: 3,
  class: "text-[12px]"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-3",
    src: _imports_0,
    alt: ""
  })
], -1))

import { computed, watch, ref } from "vue";
import NewAccountModal from "@/components/organisms/NewAccountModal.vue";
import NewAccountViewModal from "@/components/organisms/NewAccountViewModal.vue";

import { useAuthStore } from "@/stores/auth";

import { accountStore } from "@/stores/account";

import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholderAccountTab',
  setup(__props) {

const router = useRouter();

const authStore = useAuthStore();
const accountStr = accountStore();

const changed = ref<boolean>(false);
const shareholder = computed(() => authStore.user);

const accountOpen = ref<number>(0);
const visible = ref<boolean>(false);
const visibleView = ref<boolean>(false);

const activeCount = computed(() => accountStr.activeAccount);
const accounts = computed(() => accountStr.account);

watch(
  shareholder,
  (value, oldValue) => {
    if (oldValue != undefined) {
      changed.value = true;
    }
  },
  { deep: true }
);

async function setAccount(id: number) {
  accountStr.setActiveAccount(id);
  router.push({ name: "MyStocks" });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(shareholder))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h5", _hoisted_4, [
                _createTextVNode(" Mis cuentas disponibles "),
                (_unref(activeCount) == 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " - Seleccione una cuenta para comenzar"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accounts).data, (account, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: _normalizeClass(["col-span-4 lg:col-span-1 flex justify-between items-center border rounded px-3 py-2 cursor-pointer", { 'border-[#008b4e] border-2': _unref(activeCount) == account?.id }]),
                    onClick: ($event: any) => (setAccount(account?.id))
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      (
                  account?.businessName == '' || account?.businessName == null
                )
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(account?.firstName) + " " + _toDisplayString(account?.lastName), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(account?.businessName), 1)),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(account?.email), 1),
                      (account?.investorNumberA > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, " ID B: " + _toDisplayString(account?.investorNumberB) + " - ID A: " + _toDisplayString(account?.investorNumberA), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_13, " ID B: " + _toDisplayString(account?.investorNumberB), 1))
                    ]),
                    _hoisted_14
                  ], 10, _hoisted_7))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(NewAccountModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event))
    }, null, 8, ["visible"]),
    _createVNode(NewAccountViewModal, {
      visible: visibleView.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visibleView).value = $event)),
      accountOpen: accountOpen.value
    }, null, 8, ["visible", "accountOpen"])
  ], 64))
}
}

})